import { create } from "zustand";
import { toast } from "@/stores/toast";
import { currentPlatform, promptInstall, useInstallStore, type InstallPlatform } from "./install";

/** Whether the step-by-step guide (iPhone, in-app browsers) is open. */
export const useInstallGuide = create<{ open: boolean; setOpen: (open: boolean) => void }>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));

export interface InstallApi {
  platform: InstallPlatform;
  /** True when we can install here, either in one tap or by following the guide. */
  available: boolean;
  install: () => Promise<void>;
}

export function useInstall(): InstallApi {
  const canPrompt = useInstallStore((s) => !!s.deferred);
  const installed = useInstallStore((s) => s.installed);
  const openGuide = useInstallGuide((s) => s.setOpen);
  const platform = installed ? "installed" : currentPlatform(canPrompt);
  const available = platform === "prompt" || platform === "ios-safari" || platform === "ios-other" || platform === "in-app";

  const install = async () => {
    if (platform === "prompt") {
      try {
        if (await promptInstall()) toast.success("RealityStore is on your home screen", "Open it any time from your app icon.");
      } catch {
        openGuide(true);
      }
      return;
    }
    openGuide(true);
  };

  return { platform, available, install };
}
